<h1 mat-dialog-title class="tier-details-dialog-title">Tierdetails</h1>

<div mat-dialog-content class="tier-details-dialog-content">
    <kiene-gruppe-tier-details [dialog]="true" [tier]="tier" (changed)="changedDetails = $event">
    </kiene-gruppe-tier-details>
</div>

<div mat-dialog-actions class="tier-details-dialog-actions">
    <button mat-flat-button color="accent" (click)="dialogRef.close(changedDetails)">Schlie&szlig;en</button>
</div>
